<template lang="pug">
.file-name
  .label(v-for="(t, index) in fileExt", :key="index") {{ t }}
</template>
<script>
const fileReg = /\S\.\w+$/;
export default {
  props: { name: { default: "", type: String }},
  computed: {
    fileExt() {
      const text = this.name;
      const ms = text.match(fileReg);
      if (ms) {
        const { index } = ms;
        return [text.slice(0, index), text.slice(index)];
      } else {
        return [text];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.file-name {
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .label {
    font-size: inherit;
    color: inherit;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &:nth-child(2) {
      flex-shrink: 0;
    }
  }
}
</style>
